// src/firebase-config.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD4kySF8VlbEpA5CUBZAGbIJsLqIRAfuN0",
  authDomain: "bookyourneed-866f5.firebaseapp.com",
  projectId: "bookyourneed-866f5",
  storageBucket: "bookyourneed-866f5.appspot.com",
  messagingSenderId: "996262215668",
  appId: "1:996262215668:web:1fb557080c3ff67ae483a1",
  measurementId: "G-PN7R8JVNY9",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };
